// extracted by mini-css-extract-plugin
export default {"social-media-links":"IugKXqC","social-media-links__list":"Aq7mEZb","social-media-links__item":"l11hmrn"};